import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '@app/services/settings.service';
import { NavigationMenuItem, NavigationArea, Breakpoint, NavigationMenuService } from 'library-explorer';
import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Pipe({
    name: 'navigationItems',
    standalone: false
})

export class NavigationItemsPipe implements PipeTransform {

  public breakpoint$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
    .pipe(
      map(state => state.matches ? Breakpoint.MOBILE : Breakpoint.DESKTOP),
      distinctUntilChanged()
    )

  constructor(
    private breakpointObserver: BreakpointObserver,
    private readonly settingsService: SettingsService,
    private readonly navigationMenuService: NavigationMenuService) { }

  transform(items: NavigationMenuItem[], area: NavigationArea): Observable<NavigationMenuItem[]> {
    return combineLatest([
      this.settingsService.getSettings(),
      this.breakpoint$
    ])
      .pipe(
        map(([settings, breakpoint]) => {
          if (area === NavigationArea.BOTTOM_NATIVE_BAR) {
            breakpoint = Breakpoint.MOBILE;
          }

          return this.getActiveMenuItems(items, settings?.menu?.[area], breakpoint);
        })
      )
  }


  private getActiveMenuItems(menu: NavigationMenuItem[], menuSettings = null, breakpont = Breakpoint.DESKTOP): NavigationMenuItem[] {
    this.updateMenuWeightsAndSort(menu, menuSettings, breakpont);
    const activeNavigation = menu.filter(item => !item.hidden);
    this.navigationMenuService.sortMenuPreserveUnweighted(activeNavigation);

    return activeNavigation;
  }

  private updateMenuWeightsAndSort(menu: NavigationMenuItem[], menuSettings = null, breakpoint = Breakpoint.DESKTOP): void {
    menu.forEach(item => {
      const breakpointSettings = menuSettings?.[item.key]?.[breakpoint];
      Object.assign(item, { weight: breakpointSettings?.weight, hidden: breakpointSettings ? !breakpointSettings?.visible : false })
    });
  }

}
